import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import "c3/c3.min.css";

import App from "./App";
import "./index.css";
import { AuthProvider } from "./authSetup";
import userManager from "user-manager";
import { unregister } from "./registerServiceWorker";
import { UIModalProvider } from "components/UI/Modal/Context";
import theme from "./theme";
import store, { history } from "./store";

render(
  <Provider store={store}>
    <AuthProvider store={store} userManager={userManager}>
      <ThemeProvider theme={theme}>
        <UIModalProvider>
          <Router history={history}>
            <App />
          </Router>
        </UIModalProvider>
      </ThemeProvider>
    </AuthProvider>
  </Provider>,
  document.getElementById("root")
);

unregister();
